// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2voHn","modalContent":"Modal_modalContent__3QS21","modalDanger":"Modal_modalDanger__27B3F","modalEditLink":"Modal_modalEditLink__2FfZS"};